import React from 'react';
import { mobileBottomTabsFeed } from '../../../util/types';

import css from './MobileBottomTabs.module.css';

export default function MobileBottomTabs(props) {
  const {
    handleIconClick
  } = props;

  return (
    <div className={css.bottomNavBar}>
      {mobileBottomTabsFeed.map((item) => (
        <div key={item.tab} onClick={() => handleIconClick(item)}>
          {item.Icon}
        </div>
      ))}
    </div>
  );
};
